import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PlandayService } from './planday.service';
import { PlandayEditContainerComponent } from '@fi-app/external-platform-integration/planday/planday-edit-container/planday-edit-container.component';
import { PlandaySettingsComponent } from '@fi-app/external-platform-integration/planday/planday-settings/planday-settings.component';
import { UIRouterModule } from '@uirouter/angular';
import { PlandayStates } from '@fi-app/external-platform-integration/planday/planday-states';
import { FiAppTextSharedModule } from '@fi-shared/app-text';
import { FiButtonBackNewModule } from '@fi-shared/fi-button-back-new/fi-button-back-new.module';
import { FiTabsModule } from '@fi-app/utilities/tabs/tabs.module';
import { FiValidatingFormModule } from '@fi-shared/fi-directives/fi-validating-form/fi-validating-form.module';
import { SelectSearchModule } from '@fi-shared/fi-select-search/select-search.module';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { PlandayRolesMatchingComponent } from './planday-roles-matching/planday-roles-matching.component';
import { PlandayUnitsMatchingComponent } from './planday-units-matching/planday-units-matching.component';
import { PlandayUsersMatchingComponent } from './planday-users-matching/planday-users-matching.component';
import { PlandayMatchUnitsWithAreasComponent } from './planday-match-units-with-areas/planday-match-units-with-areas.component';
import { PlandayImportUnitsComponent } from './planday-import-units/planday-import-units.component';
import { MatCardModule } from '@angular/material/card';
import { FiToggleSwitchModule } from '@fi-shared/fi-toggle-switch/fi-toggle-switch.module';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { TextFieldModule } from '@angular/cdk/text-field';
import { FiTwoColumnsContainerModule } from '@fi-shared/fi-two-columns-container/fi-two-columns-container.module';
import { PlandayIntegrationGuide } from '@fi-app/external-platform-integration/planday/planday-settings/planday-integration-guide/planday-integration-guide.component';
import { PlandaySettingsFormComponent } from '@fi-app/external-platform-integration/planday/planday-settings/planday-settings-form/planday-settings-form.component';
import { PlandayImportUsersComponent } from './planday-import-users/planday-import-users.component';
import { FiAutocompleteItemsModule } from '@fi-shared/fi-autocomplete-items/fi-autocomplete-items.module';
import { PlandayImportLogComponent } from './planday-import-log/planday-import-log.component';

@NgModule({
    imports: [
        CommonModule,
        UIRouterModule.forChild(PlandayStates),
        FiAppTextSharedModule,
        FiButtonBackNewModule,
        FiTabsModule,
        FiValidatingFormModule,
        SelectSearchModule,
        FormsModule,
        MatButtonModule,
        MatSlideToggleModule,
        MatCheckboxModule,
        MatCardModule,
        FiToggleSwitchModule,
        MatFormFieldModule,
        MatInputModule,
        TextFieldModule,
        FiTwoColumnsContainerModule,
        FiAutocompleteItemsModule,
    ],
    declarations: [
        PlandayEditContainerComponent,
        PlandaySettingsComponent,
        PlandayRolesMatchingComponent,
        PlandayUnitsMatchingComponent,
        PlandayUsersMatchingComponent,
        PlandayMatchUnitsWithAreasComponent,
        PlandayImportUnitsComponent,
        PlandayIntegrationGuide,
        PlandaySettingsFormComponent,
        PlandayImportUsersComponent,
        PlandayImportLogComponent,
    ],
    providers: [PlandayService],
})
export class PlandayModule {}
